export default __webpack_public_path__ + "static/media/nexity-policy-en.30224941.pdf";